import { animate, style, transition, trigger } from '@angular/animations';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';

const initialDelayMs = 500;
const oldOddsShiftDurationMs = 500;
const newOddsDelayMs = 0;
const newOddsScaleDurationMs = 500;

export const oddsBoostAnimations = [
    trigger('oldOddsAnimation', [
        transition(oddsChanged, [
            style({ 'transform': 'translateX(140%)', 'opacity': '1', 'text-decoration': 'none' }),
            animate(`${oldOddsShiftDurationMs}ms ${initialDelayMs}ms cubic-bezier(.03,1.06,.48,1)`),
        ]),
    ]),
    trigger('newOddsAnimation', [
        transition(oddsChanged, [
            style({ transform: 'scale(0)' }),
            animate(`${newOddsScaleDurationMs}ms ${oldOddsShiftDurationMs + initialDelayMs + newOddsDelayMs}ms cubic-bezier(.7,1.57,1,1)`),
        ]),
    ]),
];

export const oddSelectors = '@oldOddsAnimation, @newOddsAnimation';

export function oddsChanged(previousOdd: Nullable<string>, newOdd: Nullable<string>): boolean {
    return !!newOdd && newOdd !== 'void' && previousOdd !== newOdd;
}
